export default __webpack_public_path__ + "8c7b4360a5b68a197942036d1938e84f.jpg";